import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  createExpenseOut,
  getExpenseOuts,
  RESET_CASHINOUT,
  selectSuccessExpense,
  updateExpenseEntry,
} from "../../redux/features/cashInOut/CashInOutSlice";
import { selectDayStatus } from "../../redux/features/dayStart/DayStartSlice";
import { toast } from "react-toastify";
import { MdEdit } from "react-icons/md";
import {
  getIngredients,
  selectIngredients,
} from "../../redux/features/ingredient/IngredientSlice";
import {
  getConsumerItem,
  selectConsumerItems,
} from "../../redux/features/item/ItemSlice";
import Select from "react-select";
import { useGetAllExpenseItemsQuery } from "../../redux/features/expenseItem/expenseItemApi";

const ExpenseOut = ({ expense }) => {
  const dayStatus = useSelector(selectDayStatus);
  const [isOpen, setIsOpen] = useState(false);
  const [amount, setAmount] = useState();
  const [expenseNote, setExpenseNote] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("expenseItem");
  const {data,isLoading,isFetching} = useGetAllExpenseItemsQuery()
  const [itemDetail, setItemDetail] = useState({
    itemId: "",
    itemName: "",
    itemQuantity: "",
    unitOfMeasure: "",
    type:""
  });

  const [expenseItemDetail, setExpenseItemDetail] = useState({
    itemId: "",
    itemName: "",
  });

  const options = [
    { value: "expenseItem", label: "Expense Item" },
    { value: "itemDetail", label: "Item Detail" },
    { value: "other", label: "Other" },
  ];

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectSuccessExpense);
  const ingredients = useSelector(selectIngredients);
  const consumerItems = useSelector(selectConsumerItems);
  const expenseItem = data?.data

  const handleOpen = () => {
    if (dayStatus) {
      setIsOpen(true);
    } else {
      toast.error("Day is closed. Cannot place expense.");
    }
  };
  const handleClose = () => {
    setIsOpen(false);
    setSelectedOption("")
    setExpenseNote("");
    setExpenseItemDetail({
    itemId: "",
    itemName: "",
  })
  setItemDetail({
    itemId: "",
    itemName: "",
    itemQuantity: "",
    unitOfMeasure: "",
    type:""
  });
    setAmount();
    setErrors({});
  };

  useEffect(() => {
    if (isOpen && expense && !expense?.itemId) {
      setSelectedOption("other")
      setExpenseNote(expense.description);
      setAmount(expense.balance);
    }else if(isOpen && expense){ 
      setSelectedOption("itemDetail")
        setAmount(expense.balance);
        setItemDetail((prev) => ({
          ...prev,
          itemId: expense.itemId || "",
          itemName: combinedOptions.find((opt) => opt.value === expense.itemId)?.label || "",
          itemQuantity: expense.itemQuantity || "",
          unitOfMeasure: combinedOptions.find((opt) => opt.value === expense.itemId)?.unit || "",
          type: expense.type || "",
        }));

    }
  }, [expense, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (selectedOption === "itemDetail") {
      if (!itemDetail.itemId) newErrors.itemId = "Item is required";
      if (!itemDetail.itemQuantity)
        newErrors.itemQuantity = "Quantity is required";
      if (itemDetail.itemQuantity <= 0)
        newErrors.itemQuantity = "Quantity must be greater than 0";
      if (!itemDetail.unitOfMeasure)
        newErrors.unitOfMeasure = "Unit of Measure is required";
    }

    if (selectedOption === "expenseItem") {
       if (!expenseItemDetail.itemId) newErrors.itemId = "Expense Item is required";
    }

    if (!expenseNote && selectedOption ==="other") newErrors.expenseNote = "Expense Note is requried";
    if (!amount) newErrors.amount = "Expense Amount is requried";
    if (amount <= 0) newErrors.amount = "Expense Amount always greater then 0";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   let note = "";

  if (selectedOption === "itemDetail") {
    note =
      itemDetail.itemName +
      " " +
      itemDetail.itemQuantity +
      " " +
      itemDetail.unitOfMeasure;
  } else if (selectedOption === "expenseItem") {
    note = expenseItemDetail.itemName;
  }

   if (!validateForm()) return;

   setExpenseNote(note);

  const expenseData = {
    description:  note || expenseNote,
    balance: Number(amount),
    expenseItemId:
      selectedOption === "expenseItem"
        ? expenseItemDetail?.itemId
        : null,
  ...(selectedOption === "itemDetail"&&{
    itemId: itemDetail?.itemId,
    itemQuantity: Number(itemDetail?.itemQuantity),
     unitOfMeasure: itemDetail?.unitOfMeasure,
     type: itemDetail?.type,
  }),
    ...(expense && { id: expense._id }),
  };

    if (expense) {
     
      await dispatch(updateExpenseEntry(expenseData));
    } else {
      await dispatch(createExpenseOut(expenseData));
    }
  };

  useEffect(() => {
    dispatch(getIngredients());
    dispatch(getConsumerItem());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      dispatch(RESET_CASHINOUT());
      dispatch(getExpenseOuts());
    }
  }, [isSuccess, dispatch]);

  const handleChange = (key, value) => {
    if (key === "itemId") {
      const selected = combinedOptions.find((opt) => opt.value === value);
      setItemDetail((prev) => ({
        ...prev,
        itemId: value,
        itemName: selected?.label,
        unitOfMeasure: selected?.unit || "",
        type: selected?.type || "",
      }));
    } if (key ==="expenseItem") {
      const selected = expenseItemOptions.find((opt) => opt.value === value);
      setExpenseItemDetail((prev) => ({
        ...prev,
        itemId: value,
        itemName: selected?.label,
      }));
    } else {
      setItemDetail((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const combinedOptions = [
    ...(consumerItems?.map((item) => ({
      value: item._id,
      label: item.name,
      unit: item.purchaseUnit,
      type: "item",
    })) || []),
    ...(ingredients?.map((ingredient) => ({
      value: ingredient._id,
      label: ingredient.name,
      unit: ingredient.purchaseUnit,

      type: "ingredient",
    })) || []),
  ];

  const expenseItemOptions = [
    ...(expenseItem?.map((item) => ({
      value: item._id,
      label: item.name,
    })) || []),
   
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      borderBottom: "1px solid #0D868C",
      borderRadius: "0px",
      boxShadow: "none",
      outline: "none",
      backgroundColor: "transparent",
      minHeight: "30px",
      padding: "none",
      textTransform: "capitalize",
      cursor: "pointer",
      "&:hover": {
        borderBottom: "1px solid #0D868C",
        boxShadow: "none",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 130,
      overflowY: "auto",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#A9A9A9",
      fontSize: "0.9rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#A9A9A9",
      fontSize: "0.9rem",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0D868C"
        : state.isFocused
        ? "#E0F7FA"
        : "white",
      color: state.isSelected ? "white" : "#0D868C",
      padding: "4px",
      fontSize: "0.9rem",
      textTransform: "capitalize",
    }),
  };

  return (
    <div>
      {/* Button to open the modal */}
      {expense ? (
        <div
          onClick={handleOpen}
          className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer"
        >
          <MdEdit className="lg:size-6 size-5" />
        </div>
      ) : (
        <button
          onClick={handleOpen}
          className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        >
          <FaPlus className="md:text-xl text-[1rem]" />
        </button>
      )}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[650px] w-[90%] mx-auto p-10 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-8">
              <h1 className="md:text-[1.75rem] text-[1rem] font-bold text-[#0D868C]">
                {expense ? "Update Expense" : "Create Expense"}
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
              <div className="flex flex-wrap gap-6">
                {options.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="radioGroup"
                      value={option.value}
                      checked={selectedOption === option.value}
                      onChange={() => setSelectedOption(option.value)}
                      className="accent-[#0D868C]  w-4 h-4"
                    />
                    <span className="text-base text-[#7D7D7D] font-semibold">
                      {option.label}
                    </span>
                  </label>
                ))}
              </div>
              {selectedOption === "itemDetail" ? (
                <div className="w-full flex flex-col ">
                  <div className="w-full flex items-end gap-2 ">
                    {/* Select Dropdown */}
                    <div className=" flex flex-col items-start w-[40%]">
                      <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                        Item Detail
                      </label>

                      <Select
                        options={combinedOptions}
                        value={
                          combinedOptions.find(
                            (opt) => opt.value === itemDetail.itemId
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleChange("itemId", selectedOption?.value)
                        }
                        placeholder="Search Item"
                        styles={customStyles}
                        isSearchable
                        className="w-full text-[.9rem] font-normal text-[#A9A9A9] outline-none"
                      />
                    </div>
                    {/* Number Input */}

                    <div className="flex-1  ">
                      <div className="flex items-end justify-between gap-2">
                        <div className="flex-grow  flex flex-col items-start ">
                          <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                            Quantity
                          </label>
                          <input
                            type="number"
                            name="ingredientQuantity"
                            min={0}
                            step={0.01}
                            onWheel={(e) => e.target.blur()}
                            value={itemDetail.itemQuantity}
                            onChange={(e) =>
                              handleChange("itemQuantity", e.target.value)
                            }
                            placeholder="Enter the quantity"
                            className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                          />
                        </div>

                        <div className="flex-grow  flex flex-col items-start">
                          <span
                            className="text-[.75rem] font-semibold text-[#7D7D7D]"
                            title="unit Of Measure"
                          >
                            UOM
                          </span>
                          <input
                            type="text"
                            value={itemDetail.unitOfMeasure}
                            readOnly
                            placeholder="Unit Of Measure"
                            className="w-full outline-none rounded-none text-[1rem] bg-[#f5f4f4] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.itemId && (
                    <p className="text-red-500 text-sm mt-1">{errors.itemId}</p>
                  )}
                  {errors.itemQuantity && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.itemQuantity}
                    </p>
                  )}
                  {errors.unitOfMeasure && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.unitOfMeasure}
                    </p>
                  )}
                </div>
              ) : selectedOption === "expenseItem" ?(
                <div className=" flex flex-col items-start w-full">
                      <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                       Expense Item Detail
                      </label>

                      <Select
                        options={expenseItemOptions}
                        value={
                          expenseItemOptions.find(
                            (opt) => opt.value === expenseItemDetail.itemId
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleChange("expenseItem", selectedOption?.value)
                        }
                        placeholder="Search expense item"
                        styles={customStyles}
                        isSearchable
                        className="w-full text-[.9rem] font-normal text-[#A9A9A9] outline-none"
                      />
                       {errors.itemId && (
                    <p className="text-red-500 text-sm mt-1">{errors.itemId}</p>
                    
                  )}
                    </div>
              ): (
                <div className=" flex flex-col items-start">
                  <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                    Expense Reason
                  </label>
                  <input
                    value={expenseNote}
                    onChange={(e) => setExpenseNote(e.target.value)}
                    type="text"
                    placeholder="Write the expense reason"
                    className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                  />
                  {errors.expenseNote && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.expenseNote}
                    </p>
                  )}
                </div>
              )}

              <div className=" flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Expense Amount
                </label>
                <input
                  type="number"
                  min={0}
                  step={1}
                  onWheel={(e) => e.target.blur()}
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Expense amount 300, 400 etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.amount && (
                  <p className="text-red-500 text-sm mt-1">{errors.amount}</p>
                )}
              </div>

              <div className="text-center ">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  {expense ? "Update Expense" : "Create Expense"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpenseOut;
